<template>
    <el-dialog id="levelSelect" v-model="dialogFlowVisible" class="noPaddingDialog" :show-close='false' width="730px" :append-to-body="true">
      <el-row class="organizationStructure">
        <el-col :span="12" class="flowLeft">
          <div class="flowTitle">选择用户</div>
            <div class="flowBody">
              <el-scrollbar style="height:92%" class="el-menu-scrollbar__wrap">
                <el-checkbox-group v-model="checkedFlow" @change="handleCheckedFlow" :max="radioUser?1:Infinity">
                  <el-checkbox v-for="flow in flows" :label="flow" :key="flow.id" :disabled="checkboxDisabled?true:false">{{flow.name}}
                    <template v-for="(orgname,orgi) in flow.orgname?flow.orgname.split(','):[]">
                      <span class="orgname ellipsis" :key="orgname" v-if="orgi<2">{{orgname}}</span>
                    </template>
                  </el-checkbox>
                </el-checkbox-group>
              </el-scrollbar>
            <div class="flowFoot"><el-checkbox :indeterminate="flowIndeterminate" v-model="flowCheckAll" @change="handleCheckAllFlow" :disabled="radioUser?true:false">全选</el-checkbox></div>
          </div>
        </el-col>
        <el-col :span="12" class="flowRight">
        <div class="flowTitle">已选择<font style="color:#4e86ff">({{checkedFlow.length}})</font><el-button type="text" style="float:right" @click="handleCheckAllFlow(false)">清空</el-button></div>
          <div class="flowBody">
            <el-scrollbar style="height:100%" class="el-menu-scrollbar__wrap">
              <el-tag type="info" :key="tag.id" v-for="tag in checkedFlow" closable :disable-transitions="false" @close="handleClose(tag)" style="margin:10px 5px"> {{tag.name}} </el-tag>
            </el-scrollbar>
            <div class="flowFoot">
              <el-button size='medium' type="yeprimary" @click="submit">确定</el-button>
              <el-button size='medium' @click="closeLevelSelect">取消</el-button>
            </div>
          </div>
        </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'levelSelect',
  props:["param"],
  data () {
    return {
      //公文流转
      flowCheckAll: false,
      checkedFlow: ['三级主管', '二级主管'],
      flows: [],
      dialogFlowVisible:false,
      flowIndeterminate: true,
      radioUser:false,//单选
      checkboxDisabled:false,
    }
  },
  methods: {
    levelSelectChild(item){
      this.flows = [];
      this.checkedFlow=[]
      this.radioUser=false;
      if(item){
        if(item.checkedList){//数据列表
          this.flows = item.checkedList
          if(item.checkedFlow&&item.checkedFlow.length>0||(this.flows.length>0&&!this.flows[0].name)){//选中数据
            this.flows.forEach(e => {
              if(!e.name){e.name=e.realname}
              item.checkedFlow.forEach(j =>{
                if(e.userId==j.userId){
                  this.checkedFlow.push(e)
                }
              })
            });
          }
        }
        if(item.radioUser){
          this.radioUser=item.radioUser
        }
      }
      this.dialogFlowVisible=true;
    },
    handleCheckAllFlow(val) {
      this.checkedFlow=[]
      if(val){
        this.flows.forEach(e =>{
          this.checkedFlow.push(e);
        })
      }
      this.flowIndeterminate = false;
    },
    handleCheckedFlow(value) {
      let flowCheckedCount = value.length;
      this.flowCheckAll = flowCheckedCount === this.flows.length;
      this.flowIndeterminate = flowCheckedCount > 0 && flowCheckedCount < this.flows.length;
    },
    handleClose(tag) {
      this.checkedFlow.splice(this.checkedFlow.indexOf(tag), 1);
      },
    closeLevelSelect(){
      this.dialogFlowVisible = false
       //第一个参数名为调用的方法名，第二个参数为需要传递的参数
    },
    submit(){
      this.$emit('fromLevelSelect',JSON.parse(JSON.stringify(this.checkedFlow)))
      this.dialogFlowVisible = false
    },
  },
  watch:{
    checkedFlow(){
      if(!this.radioUser||this.checkedFlow.length<1){
        this.checkboxDisabled=false
      }else{
        this.checkboxDisabled=true
      }
    },
  },
	mounted() {

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
<style scoped>
  .flowLeft{border-right:1px solid #e5e5e5}
  .flowTitle{height:48px;line-height:48px;background:#fafafa;border-bottom: 1px solid #e5e5e5;padding:0 10px;color:#999}
  .flowBody{height:540px;position: relative;}
  .flowFoot{border-top:1px solid #e5e5e5;padding:12px 5%;position: absolute;bottom:0;left:0;width:90%;}
  .flowRight .flowFoot{padding:18px 5%;text-align:center;}
  .el-checkbox-group .el-checkbox{display:block;margin:10px 14px 10px 0;padding:6px 10px}
  .el-checkbox-group .el-checkbox:nth-child(odd){background:#FBFBFB}
  .orgname{color: #666;background: #F4F3F3;font-size: 90%;padding: 2px 4px 0;margin:0 3px;border-radius: 2px;max-width: 90px;display: inline-block;vertical-align: middle}
</style>
